import React from 'react'

export interface OpenInNewTabLinkRendererProps {
    href?: string
    children?: React.ReactNode
}

const OpenInNewTabLinkRenderer = ({
    href,
    children,
    ...props
}: OpenInNewTabLinkRendererProps) => {
    // Accessibility
    const handleKeyDown = React.useCallback(
        (event: React.KeyboardEvent<HTMLAnchorElement>): void => {
            if (event.key === 'Enter') {
                event.stopPropagation()
                event.preventDefault()

                // Open the link in a new tab
                window.open(href, '_blank')
            }
        },
        [href]
    )

    // target="_blank" => allows the link to open in a new tab
    // rel="noopener noreferrer" => prevents the new tab from accessing the window.opener property (security)
    return (
        <a
            href={href}
            role="button"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open in new tab"
            data-testid="newTabLinkRenderer"
            onKeyDown={(e) => handleKeyDown(e)}
            {...props}
        >
            {children}
        </a>
    )
}
export default OpenInNewTabLinkRenderer
